export enum RoadKillSymbolStates {
    NORMAL = "NORMAL",
    SPIN = "SPIN",
    WIN = "WIN",
    NO_WIN = "NO_WIN",
    LAND = "land",
    SPLIT="_idle",
    SPLIT_WIN="_win"
}

export enum SimpleReelModelState {
    IDLE = "IDLE",
    START = "START",
    SPIN = "SPIN",
    STOP = "STOP",
    STOPPED = "STOPPED",
    BOUNCE = "BOUNCE",
    NUDGE = "NUDGE",
}

export enum JumpingWildAnimStates {
    TRIGGER = "trigger",
    IDLE = "idle",
    HIT_LEFT = "hit_left",
    HIT_RIGHT = "hit_right",
    IN = "in",
    OUT = "out",
    WIN = "win",
    WIN_STATE = "win_state",
    JUMP = "jump",
    UPGRADE = "upgrade",
    UPGRADE_FROM_IN = "upgrade_from_in"
}

export enum JumpinWildSkins {
    DEFAULT = "default",
    NORMAL = "normal",
    UPGRADED = "lvl5"
}

export enum CAR_STATES {
    IDLE = "IDLE",
    START = "START",
    MOVING = "MOVING",
    STOP = "STOP",
    STOPPED = "STOPPED",
}

export enum JW_TYPE {
    DEER = "DEER",
    BEAR = "BEAR",
    RABBIT = "RABBIT",
    TRAP = "TRAP",
    COMBINED_AMINALS = "COMBINED_ANIMALS"
}

export enum HEART_STATE {
    IN,
    OUT,
    GOLDEN,
    GOLDEN_OUT
}

export enum CAR_NAMES{
    RED="red",
    GREEN="green"
}

export enum DIRECTION {
    LEFT = "FromLeft",
    RIGHT = "FromRight",
    TOP = "FromTop",
    BOTTOM = "FromBottom"
}

export enum SYMBOL_NAME {
    M1 = "M1",
    M2 = "M2",
    M3 = "M3",
    M4 = "M4",
    M5 = "M5",
    L1 = "L1",
    L2 = "L2",
    L3 = "L3",
    L4 = "L4",
    L5 = "L5",
    WILD = "W",
    SW1 = "SW1",
    SW2 = "SW2",
    SW3 = "SW3",
    SCATTER = "S1"
}